import { createFileRoute } from '@tanstack/react-router';

import { DealEditorPage } from '../features/demand/deals/components/DealEditorPage';

export const Route = createFileRoute('/demand/deals/create')({
  component: DealCreateRoute,
});

function DealCreateRoute() {
  return <DealEditorPage />;
}
